import { render } from "./open_jobs.vue?vue&type=template&id=56b52264&scoped=true"
import script from "./open_jobs.vue?vue&type=script&lang=js"
export * from "./open_jobs.vue?vue&type=script&lang=js"

import "./open_jobs.vue?vue&type=style&index=0&id=56b52264&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b52264"]])

export default __exports__